import { StringSchema } from 'yup';

export const telephoneValidate = (value: string) => {
  const telephoneRegex = /^[1-9]{2}[2-6][0-9]{7}$/;

  return telephoneRegex.test(value);
};

export function telephone(this: StringSchema, message = 'Insira um telefone válido') {
  return this.test('telephone', message, (value = '') => telephoneValidate(value));
}
